import React from "react"
import ReactDOM from "react-dom/client"
import {Provider} from "react-redux"
import {BrowserRouter} from "react-router-dom";
import {createBrowserHistory} from "history";
import {SnackbarProvider} from 'notistack';

import {store} from "./_store"

import './index.sass'
import App from "./App";

export const history = createBrowserHistory()

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <BrowserRouter history={history}>
            <SnackbarProvider anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} max={6}>
                <App/>
            </SnackbarProvider>
        </BrowserRouter>
    </Provider>);